import { ContentCopy } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import DialogInner from "./DialogInner";
import { useAppSelector } from "../../../App/State/Hooks/reduxHooks";
import { selectClientValue } from "../../../App/State/Slices/SelectedClientSlice";
import { useNotification } from "../../../App/State/Hooks/notificationHooks";

interface IEmbedScriptInnerProps {
  campaignName: string;
  campaignId: string;
  forms: any[];
  handleClearDialog?: () => void;
}

// TODO: Create fetch script endpoint, this is a placeholder implementation for now

export function EmbedScriptInner({
  campaignName,
  campaignId,
  forms,
  handleClearDialog,
}: IEmbedScriptInnerProps) {
  const { displayInfo } = useNotification();
  const { clientName } = useAppSelector(selectClientValue);
  const comment = `<!-- Client Name: ${clientName} - Form Name: ${campaignName} -->\n`;
  const script = `<div id="activate-form" data-id="${campaignId}" data-form="${
    forms[0]?.id ?? "undefined"
  }"></div>\n<script type="module" src="${import.meta.env.VITE_LEADCAPTURE_FORM}"></script>`;

  function handleCopyScript() {
    navigator.clipboard.writeText(comment + script);
    displayInfo("Embed code copied to clipboard");
  }

  return (
    <DialogInner title="Embed Form Script" id="embedscript" handleClearDialog={handleClearDialog}>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box
          sx={{
            p: "0 1rem",
          }}
        >
          <Typography component="span">Form:</Typography>
          <Typography
            id="campaign-name-header"
            sx={(theme) => ({
              fontFamily: theme.typography.h3.fontFamily,
              fontSize: theme.typography.h5.fontSize,
              mb: "1rem",
            })}
          >
            {campaignName}
          </Typography>
          <Typography
            sx={{
              mb: "1rem",
            }}
          >
            Copy & paste this HTML snippet into any website to start getting candidates added directly to the
            CRM.
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: "#f5f5f5",
            px: 2,
            mb: "1rem",
            borderRadius: 2,
          }}
          id="campaign-form-script"
        >
          <pre>
            <code style={{ whiteSpace: "pre-wrap" }}>
              <span style={{ color: "rgba(0, 0, 0, 0.5)" }}>{comment}</span>
              {script}
            </code>
          </pre>
          <IconButton
            onClick={handleCopyScript}
            aria-label="Copy embed code to clipboard"
            title="Copy embed code to clipboard"
          >
            <ContentCopy fontSize="small" />
          </IconButton>
        </Box>
      </Box>
    </DialogInner>
  );
}
